export const validateForm = (event, setErrorForm, showError = false) => {
    let erro = 0

    let target = event.target || event

    let selects = target.getElementsByTagName('select')
    let inputs = target.getElementsByTagName('input')

    let value = {}

    Object.keys(selects).forEach((el) => {
        let require = selects[el].getAttribute('data-required')
        if(require){
            if(selects[el].value === ''){
                if (showError) selects[el].classList.add("error")
                erro++
            }else{
                value[selects[el].name] = selects[el].value
            }
        }
    })

    Object.keys(inputs).forEach((el) => {
        let require = inputs[el].getAttribute('data-required')
        if(require === 'true' || require){
            if(inputs[el].value === ''){
                if (showError) inputs[el].classList.add("error")
                erro++
            }else{
                value[inputs[el].name] = inputs[el].value
            }
        } else if (inputs[el].value){
            value[inputs[el].name] = inputs[el].type === 'checkbox' ?  (inputs[el].checked ? 1 : 0) : inputs[el].value
        }
    })

    setErrorForm(erro > 0)
    if(erro > 0){
        return { error: true }
    }
    
    return { error: false, value: value }
}